/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PracticeBranchInfoDto
 */
export interface PracticeBranchInfoDto {
    /**
     * Branch name
     * @type {string}
     * @memberof PracticeBranchInfoDto
     */
    name: string;
    /**
     * Branch address
     * @type {string}
     * @memberof PracticeBranchInfoDto
     */
    address: string;
    /**
     * Branch city
     * @type {string}
     * @memberof PracticeBranchInfoDto
     */
    city: string;
    /**
     * Branch state
     * @type {string}
     * @memberof PracticeBranchInfoDto
     */
    state: string;
    /**
     * Branch zip
     * @type {string}
     * @memberof PracticeBranchInfoDto
     */
    zip: string;
    /**
     * Branch phone
     * @type {string}
     * @memberof PracticeBranchInfoDto
     */
    phone: string;
    /**
     * Branch email
     * @type {string}
     * @memberof PracticeBranchInfoDto
     */
    email?: string;
}

/**
 * Check if a given object implements the PracticeBranchInfoDto interface.
 */
export function instanceOfPracticeBranchInfoDto(value: object): value is PracticeBranchInfoDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('zip' in value) || value['zip'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    return true;
}

export function PracticeBranchInfoDtoFromJSON(json: any): PracticeBranchInfoDto {
    return PracticeBranchInfoDtoFromJSONTyped(json, false);
}

export function PracticeBranchInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PracticeBranchInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'address': json['address'],
        'city': json['city'],
        'state': json['state'],
        'zip': json['zip'],
        'phone': json['phone'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function PracticeBranchInfoDtoToJSON(json: any): PracticeBranchInfoDto {
    return PracticeBranchInfoDtoToJSONTyped(json, false);
}

export function PracticeBranchInfoDtoToJSONTyped(value?: PracticeBranchInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'address': value['address'],
        'city': value['city'],
        'state': value['state'],
        'zip': value['zip'],
        'phone': value['phone'],
        'email': value['email'],
    };
}

